import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Box, Modal, Typography, Grid } from "@mui/material";
import '../../styles/frame.css'

import TermsAndConditions from "../overlays/TermsAndConditions";
import PrivacyPolicy from "../overlays/PrivacyPolicy"

import { useIdleTimer, workerTimers } from 'react-idle-timer';
import { userKeepAlive } from "../../reducers/auth_timeout";
import TimeoutHandler from "./TimeoutHandler";

const Footer = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation()
  const { user: currentUser } = useSelector((state) => state.auth) || "";


  const [callVI, setCallVI] = useState(false)
  
  const { viewInstance, settings } = useSelector(state => state.viewinstance)



  // Time before idle
  // const [remaining, setRemaining] = useState(0)
  // const [open, setOpen] = useState(false)
  // const onPrompt = () => {
  //   if (currentUser) {
  //     // setOpen(true)
  //     setRemaining(promptTimeout)
  //   }
  // }

  //   const onIdle = () => {
  //   //console.log('idling', currentUser)
  //   if (currentUser) {
  //     const whatever = 1
  //     //setOpen(false)
  //     // setRemaining(0)
  //     // dispatch(userLogout())
  //     // dispatch(authClear())
  //     // navigate('/logout')
  //   }
  // }
  // const onActive = () => {
  //   console.log('active')

  //   dispatch(userKeepAlive())
  //   setOpen(false)
  // }  

  // const onAction = () => {

  //   dispatch(userKeepAlive())

  // }
  // const { getRemainingTime, isPrompted, activate } = useIdleTimer({
  //   timeout,
  //   promptTimeout,
  //   onPrompt,
  //   onIdle,
  //   onActive,
  //   onAction,

  //   debounce: 10000,
  //   events: [
  //     'mousemove',
  //     'keydown',
  //     'wheel',
  //     'DOMMouseScroll',
  //     'mousewheel',
  //     'mousedown',
  //     'touchstart',
  //     'touchmove',
  //     'MSPointerDown',
  //     'MSPointerMove',
  //     'visibilitychange',
  //     'focus'
  //   ]
  // })


  // const handleStillHere = () => {
  //     setOpen(false)
  //     dispatch(userKeepAlive())

  //     activate()
  //   }

  // useEffect(() => {
  //   if (currentUser) {
  //     const interval = setInterval(() => {
  //       if (isPrompted()) {

  //         setRemaining(Math.ceil(getRemainingTime() / 1000))
  //       }
  //     }, 5000)
  //     return () => {
  //       clearInterval(interval)
  //     }
  //   }

  // }, [getRemainingTime, isPrompted])

  // useEffect(() => {

  //     if (Math.min(promptTimeout, 90000) >= (timeoutRemaining * 1000) && currentUser && currentUser.AuthToken && timeout >= 0 && timeoutRemaining) {
  //         setOpen(true)
  //     } else {
  //         setOpen(false)
  //     }

  // }, [timeoutRemaining, timeout])

  // useEffect(() => {

  //   if (
  //     settings 
  //     && settings.OrganizationSettingValues 
  //     && settings.OrganizationSettingValues['SESSION TIMEOUT SECONDS']
  //   ) {
  //     setTimeout(1000 * parseInt(settings.OrganizationSettingValues['SESSION TIMEOUT SECONDS'], 0))
  //   }

  //   if (
  //     settings
  //     && settings.OrganizationSettingValues
  //     && settings.OrganizationSettingValues.length > 0
  //     && settings.OrganizationSettingValues[0].List
  //     && settings.OrganizationSettingValues[0].List['SESSION TIMEOUT SECONDS']
  //   ) {
  //     setTimeout(1000 * parseInt(settings.OrganizationSettingValues[0].List['SESSION TIMEOUT SECONDS'], 0))
  //   }
  // }, settings)


  // useEffect(() => {
  //   //IF EMPTY VI OR NOT THE DESIRED VI AND THE VI HAS NOT BEEN CALLED YET
  //   if ((!viewInstance || !viewInstance.VI_NAME) && !callVI) {
  //     //SO IT'S NOT CALLED MULTIPLE TIMES
  //     setCallVI(true)
  //     //CALL THE ACTION THAT FETCHES THE SERVICE AND UPDATES THE STATE
  //     //dispatch(GETVI(searchParams.get("g"), -1))
  //   }
  //   //WINDOW.LOCATION PROVIDES EXTRA CONTEXT SO WHEN TEH URL UPDATES THE APP UPDATES
  // }, [window.location.pathname])



  return (
    <Box my={3} sx={{
      fontSize: "12px",
      mb: 1,
      mt: 1,
      alignItems: "center",
      alignContent: "center",
      textAlign: "center"
    }} className="footer">
      <Grid container direction="row" spacing={0} alignItems="center" justifyContent="center">
        <Grid item xs={12}>
          <Typography variant="body2">WellSuite© IV A Product of Wellsource</Typography>
        </Grid>
        {location.pathname !== '/pwreset' && (

          <Grid item xs={12}>

          <TermsAndConditions />
        </Grid>
          )
        }
        <Grid item xs={12}>

          <PrivacyPolicy />
        </Grid>
      </Grid>
      <TimeoutHandler settings={settings} />
    </Box>
  );
};

export default Footer;